import { createEntitySlice } from '@/shared/store/createEntitySlice';
import type { EntityState } from '@/shared/types/entity';
import { brokenSubscriptionsApi } from '../api';
import type { BrokenSubscription, BrokenSubscriptionFilters } from '../types';

const initialState: EntityState<BrokenSubscription, BrokenSubscriptionFilters> = {
  items: [],
  loading: false,
  error: null,
  currentPage: 1,
  perPage: 20,
  total: 0,
  lastPage: 1,
  filters: {
    search: '',
    dateRange: null,
    problemCode: '',
    status: '',
  },
};

const { actions, reducer } = createEntitySlice<
  BrokenSubscription,
  BrokenSubscriptionFilters,
  never
>({
  name: 'brokenSubscriptionsEntity',
  api: {
    getList: brokenSubscriptionsApi.getList,
    getOne: () => Promise.reject(new Error('Not implemented')),
    create: () => Promise.reject(new Error('Broken subscriptions are read-only')),
    update: () => Promise.reject(new Error('Broken subscriptions are read-only')),
    delete: () => Promise.reject(new Error('Broken subscriptions are read-only')),
  },
  initialState,
  getListParams: (state) => {
    const { currentPage, perPage, filters } = state.brokenSubscriptionsEntity;
    const params: Record<string, unknown> = { page: currentPage, perPage };

    if (filters.search) {
      params.search = filters.search;
    }

    if (filters.problemCode) {
      params.problemCode = filters.problemCode;
    }

    if (filters.status) {
      params.status = filters.status;
    }

    return params;
  },
});

export const {
  fetchItems: fetchBrokenSubscriptions,
  setPage: setBrokenSubscriptionsPage,
  setPerPage: setBrokenSubscriptionsPerPage,
  setFilters: setBrokenSubscriptionsFilters,
} = actions;

export const brokenSubscriptionsReducer = reducer;
